import React, { useMemo } from 'react';
import { TPN_BEST_PRACTICE_5_3, WorkflowLabels } from '../../../../services/workflow';
import SiteDataRow from './SiteDataRow';
import { Contact, Company } from '../../../../interfaces/users.interface';
import { Workflow, WorkflowTypeKey } from '../../../../interfaces/workflow.interface';
import { useCanAddNewWorkflow } from '../../../../hooks/useCanAddNewWorkflow';

type Props = {
  company: Company;
  site: Contact;
  fullWf: Workflow[] | undefined;
  userCanAdminCompany: boolean;
  companyCallback: (c: Company) => void;
  onRowClick: (site: Contact) => void;
  handleSetCanStartNewQuestionniare: () => void;
};

export default function SiteRowWithWorkflow({
  company,
  site,
  fullWf,
  userCanAdminCompany,
  companyCallback,
  onRowClick,
  handleSetCanStartNewQuestionniare,
}: Props) {
  const workflows = useMemo(() => {
    const f = fullWf?.filter((wf) => wf.site === site.id && wf.isActive);
    return f?.sort((a, b) => b.id - a.id);
  }, [fullWf, site.id]);

  const allSiteWorkflows = useMemo(() => {
    const f = fullWf?.filter((wf) => wf.site === site.id);
    return f?.sort((a, b) => b.id - a.id);
  }, [fullWf, site.id]);

  const canAddNewWorkflow = useCanAddNewWorkflow(workflows);

  const nextWorkflowLabel = useMemo<WorkflowTypeKey>(() => {
    if (!workflows?.length) return TPN_BEST_PRACTICE_5_3;
    const idx = WorkflowLabels.indexOf(workflows[0].workflowType as WorkflowTypeKey);
    return WorkflowLabels[idx + 1] as WorkflowTypeKey;

  }, [workflows]);

  const canBeginNextQuestionnaire = useMemo(
    () => !!allSiteWorkflows?.length && canAddNewWorkflow(nextWorkflowLabel),
    [allSiteWorkflows?.length, nextWorkflowLabel, canAddNewWorkflow],
  );

  return (
    <SiteDataRow
      key={site.id}
      company={company}
      site={site}
      userCanAdminCompany={userCanAdminCompany}
      companySuccessCallback={companyCallback}
      onClick={onRowClick}
      showCanBeginNewWorkflow={canBeginNextQuestionnaire}
      setCanStartNewQuestionniare={handleSetCanStartNewQuestionniare}
    />
  );
}
